import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Divider, Grid, Stack, Tooltip, Typography } from '@mui/material';
import { RadioListItem } from 'components/Input/Radio';
import { Extension, FnAxios, FnDialog, I18n, formatNumber } from 'utilities/utilities';
import { TextBoxItem } from 'components/Input/TextBox';
import { GetMenuPermission } from 'utilities/SystemFunction';
import { SelectItem } from 'components/Input/Select/SelectItem';
import { BtnAdd, BtnBack, BtnRemark, BtnSave } from 'components/Button/ButtonAll';
import { useLocation, useNavigate } from 'react-router';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import UploadFile from 'components/Input/UploadFile';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import DialogPreview from 'components/DialogPreview/DialogPreview';
import { TextAreaItem } from 'components/Input/TextArea';
import moment from 'moment';
import { I18NextNs } from 'enum/enum';
import InputNumberItem from 'components/Input/InputNumber';

const MaterialReceiveForm = () => {
    const location = useLocation();
    const searchParams = location.search;
    const sID = new URLSearchParams(searchParams).get('sID');
    const navigate = useNavigate();
    const onBack = () => navigate("/MaterialInventoryList?sMode=" + sMode);
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [arrImport, setarrImport] = useState([])
    const [arrMaterialType, setMaterialType] = useState<any>([]);
    const [arrMaterial, setMaterial] = useState<any>([]);
    const [isOpen, setisOpen] = useState<boolean>(false);
    const [sRemark, setsRemark] = useState("");
    const [nReceiveType, setReceiveType] = useState(0);
    const [sOrder, setsOrder] = useState("");

    const sMode = new URLSearchParams(searchParams).get("sMode");
    const form = useForm({
        shouldFocusError: true,
        mode: "all"
    });
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission
    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const dataColumn: any = [
        {
            field: "nOrder",
            headerName: "ที่",
            headerAlign: "center",
            align: "center",
            resizable: false,
            sortable: false,
            width: 60,
            disableColumnMenu: true,
        },
        {
            field: "nMaterialTypeID",
            headerAlign: "center",
            align: "Left",
            sortable: false,
            flex: 1,
            width: 220,
            disableColumnMenu: true,
            renderHeader: (item) => {
                return (
                    <Typography color={"#ffff"} fontSize={14}>
                        ประเภทวัสดุ
                        <span style={{ color: "red" }}> * </span>
                    </Typography>
                )
            },
            renderCell: (item) => {
                return (
                    <FormProvider {...form}>
                        <SelectItem
                            id={`nMaterialTypeID_${item.row.sID}`}
                            name={`nMaterialTypeID_${item.row.sID}`}
                            options={arrMaterialType}
                            required={true}
                            disabled={!isPermission || sID != null}
                            placeholder={`${I18n.SetText("Material.sNameMaterialtype")}`}
                            IsShowMessageError={false}
                            onChange={(e) => {
                                getMaterialUnit(e ? e.sUnit : null, item.row.sID)
                            }}
                        />
                    </FormProvider>
                )
            }
        },
        {
            field: "nMaterialID",
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 1,
            width: 220,
            disableColumnMenu: true,
            renderHeader: (item) => {
                return (
                    <Typography color={"#ffff"} fontSize={14}>
                        รายการ
                        <span style={{ color: "red" }}> * </span>
                    </Typography>
                )
            },
            renderCell: (item) => {
                let nMaterialTypeID = form.getValues(`nMaterialTypeID_${item.row.sID}`)
                let arrData = arrMaterial.filter(f => f.nMaterialType == nMaterialTypeID);
                return (
                    <FormProvider {...form}>
                        <SelectItem
                            id={`nMaterialID_${item.row.sID}`}
                            name={`nMaterialID_${item.row.sID}`}
                            placeholder={`${I18n.SetText("Material.sMaterial")}`}
                            options={arrData}
                            required={true}
                            disabled={!isPermission || sID != null}
                            IsShowMessageError={false}
                            defaultValue={item.row.nMaterialID}
                            onChange={(e) => {
                                getMaterialUnit(e ? e.sUnit : null, item.row.sID)
                            }}
                        />
                    </FormProvider>
                )
            }
        },
        {
            field: "sUnit",
            headerName: "หน่วยนับ",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 100,
            disableColumnMenu: true,
            renderHeader: (item) => {
                return (
                    <Typography color={"#ffff"} fontSize={14}>
                        หน่วยนับ
                        <span style={{ color: "red" }}> * </span>
                    </Typography>

                )
            },
        },
        {
            field: "nAmount",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 130,
            disableColumnMenu: true,
            renderHeader: (item) => {
                return (
                    <Typography color={"#ffff"} fontSize={14}>
                        จำนวน
                        <span style={{ color: "red" }}> * </span>
                    </Typography>
                )
            },
            renderCell: (item) => {
                return (
                    <FormProvider {...form}>
                        <InputNumberItem
                            id={`nAmount_${item.row.sID}`}
                            name={`nAmount_${item.row.sID}`}
                            required={true}
                            maxDigits={2}
                            ShowDigits={0}
                            maxInteger={10}
                            min={1}
                            disabled={!isPermission || sID != null}
                            onChange={() => {
                                nSum(item.row.sID);
                            }}
                            IsShowMessageError={false}
                            IsAllowScientific={false}
                        />
                    </FormProvider>
                )
            }
        },
        {
            field: "nPricePerUnit",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 130,
            disableColumnMenu: true,
            renderHeader: (item) => {
                return (
                    <Typography color={"#ffff"} fontSize={14}>
                        ราคา / หน่วย
                        <span style={{ color: "red" }}> * </span>
                    </Typography>
                )
            },
            renderCell: (item) => {
                return (
                    <FormProvider {...form}>
                        <InputNumberItem
                            id={`nPricePerUnit_${item.row.sID}`}
                            name={`nPricePerUnit_${item.row.sID}`}
                            required={true}
                            IsShowMessageError={false}
                            maxDigits={2}
                            ShowDigits={2}
                            maxInteger={10}
                            IsAllowScientific={false}
                            disabled={!isPermission || sID != null}
                            onChange={() => {
                                nSum(item.row.sID);
                            }}
                        />
                    </FormProvider>
                )
            }
        },
        {
            field: "nTotalPrice",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 150,
            disableColumnMenu: true,
            renderHeader: (item) => {
                return (
                    <Typography color={"#ffff"} fontSize={14}>
                        จำนวนเงิน
                        <span style={{ color: "red" }}> * </span>
                    </Typography>
                )
            },
            renderCell: (item) => {
                return (
                    <Stack
                        sx={{
                            b: {
                                "@media": {
                                    maxWidth: "120px",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                },
                            },
                        }}
                    >
                        <Tooltip title={formatNumber(item.row.nTotalPrice, 2)}>
                            <Typography
                                component="b"
                            >
                                {formatNumber(item.row.nTotalPrice, 2)}
                            </Typography>
                        </Tooltip>
                    </Stack>
                );

            }
        },
        {
            field: "sRemark",
            headerName: "หมายเหตุ",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 130,
            disableColumnMenu: true,
            renderCell: (item) => {
                return (
                    <>
                        <BtnRemark
                            id={"btn" + item.row.sID}
                            IsCircleWithOutText
                            className='btnicon-remark'
                            onClick={() => onOpenModal(item.row.sID, item.row.sRemark)}
                        />
                    </>
                );

            },
        },

    ];

    const getFormInitial = () => {
        AxiosFn.Get(`MaterialInventory/GetFormInitial`, {}, (result) => {
            setMaterialType(result.lstMaterialType);
            setMaterial(result.lstMaterial);
        })
    }

    const onOpenModal = (sID, sRemark) => {
        setisOpen(true);
        setsOrder(sID);
        form.setValue("sRemark", sRemark);
        setsRemark(form.getValues(`sRemark`));
    };

    const getMaterialUnit = (sUnit, sIDRow) => {
        let arrClone = dataRow;
        if (arrClone.arrRows.length > 0) {
            arrClone.arrRows.forEach((f) => {
                f.sUnit = f.sID == sIDRow ? sUnit : f.sUnit;
            });
        }
        setDataRow({ ...arrClone });
    }

    const nSum = (sID) => {
        let nAmount = form.getValues(`nAmount_${sID}`);
        let nPricePerUnit = form.getValues(`nPricePerUnit_${sID}`);
        let nTotalPrice = nAmount * nPricePerUnit;

        let arrClone = dataRow;
        if (arrClone.arrRows.length > 0) {
            arrClone.arrRows.forEach((f) => {
                f.nTotalPrice = f.sID == sID ? nTotalPrice : f.nTotalPrice;
            });
        }
        setDataRow({ ...arrClone });
    }

    const onSummitRemark = () => {
        setisOpen(false);
        let sRemarkform = form.getValues(`sRemark`);
        let arrClone = dataRow;
        if (arrClone.arrRows.length > 0) {
            arrClone.arrRows.forEach((f) => {
                f.sRemark = f.sID == sOrder ? sRemarkform : f.sRemark;
            });
        }
        setDataRow({ ...arrClone });
    }

    //Add TableItem
    const onSumitTable = (e) => {
        let arrClone = dataRow;
        if (arrClone.arrRows.length > 0) {
            arrClone.arrRows.forEach((f) => {
                f.sID = f.sID;
                f.nOrder = f.nOrder;
                f.nMaterialTypeID = e[`nMaterialTypeID_${f.sID}`] ? e[`nMaterialTypeID_${f.sID}`] : f.nMaterialTypeID;
                f.nMaterialID = e[`nMaterialID_${f.sID}`] ? e[`nMaterialID_${f.sID}`] : f.nMaterialID;
                f.sUnit = f.sUnit;
                f.nAmount = e[`nAmount_${f.sID}`] ? +e[`nAmount_${f.sID}`] : f.nAmount;
                f.nPricePerUnit = e[`nPricePerUnit_${f.sID}`] ? +e[`nPricePerUnit_${f.sID}`] : f.nPricePerUnit;
                f.nTotalPrice = f.nTotalPrice;
                f.sRemark = f.sRemark != "" ? f.sRemark : sRemark;
            });
        }
        setDataRow({ ...arrClone });
        let param = {
            lstDataRow: dataRow.arrRows
        }
        AxiosFn.Post(`MaterialInventory/GetReceivelItem`, param, (result) => {
            setDataRow({
                ...dataRow,
                arrRows: result.lstMaterialItem,
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });

            setsRemark("");
        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        )
    };

    const onSubmit = (e, nMode) => {
        if (arrImport.length === 0) {
            return DialogFn.Warning(I18n.SetText("UploadFile.sMsgRequiredFile", I18NextNs.labelComponent) + " เอกสารใบสั่งซื้อ");
        }
        let lstDataType = []
        let lstData = []
        lstData = dataRow.arrRows;
        lstData.forEach((item) => {
            lstDataType.push({
                sID: item.sID,
                nOrder: item.nOrder,
                nMaterialTypeID: e[`nMaterialTypeID_${item.sID}`] ? e[`nMaterialTypeID_${item.sID}`] : item.nMaterialTypeID,
                nMaterialID: e[`nMaterialID_${item.sID}`] ? e[`nMaterialID_${item.sID}`] : item.nMaterialID,
                sUnit: item.sUnit,
                nAmount: e[`nAmount_${item.sID}`] ? +e[`nAmount_${item.sID}`] : item.nAmount,
                nPricePerUnit: e[`nPricePerUnit_${item.sID}`] ? +e[`nPricePerUnit_${item.sID}`] : item.nPricePerUnit,
                nTotalPrice: item.nTotalPrice,
                sRemark: item.sRemark ? item.sRemark : form.getValues("sRemark"),
            })
        })

        let param = {
            sID: sID ? sID : "",
            nReceiveType: +form.getValues("sReceiveType"),
            sReceiveTypeOther: form.getValues("sReceiveTypeOther"),
            sOrderNo: form.getValues("sOrderNo"),
            nReceiveDate: form.getValues("dReceive").valueOf(),
            fFile: arrImport ?? [],
            lstDataReceive: lstDataType,
        };

        DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(`MaterialInventory/SaveReceiveMaterial`, param, (result) => {
                DialogFn.UnBlockUI();
                DialogFn.Success(`บันทึกสำเร็จ`);
                DialogFn.CloseSubmit()
                navigate("/MaterialInventoryList?sMode=" + sMode);

            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };
    const getReceiveMaterialEdit = (p: PaginationInterface) => {
        let Param = {
            ...p,
            sID: sID ? sID : ""
        };
        DialogFn.BlockUI();
        AxiosFn.Post(`MaterialInventory/GetReceiveMaterialEdit`, Param, (result) => {
            DialogFn.UnBlockUI();
         //  getFormInitial();
            
            setDataRow({
                ...p,
                arrRows: [...result.lstDataReceive],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
            if (sID) {
             
                setTimeout(() => {
                    (result.lstDataReceive ?? []).forEach(f => {
                        f.nOrder = f.nOrder;
                        form.setValue(`nMaterialTypeID_${f.sID}`, f.nMaterialTypeID);
                        form.setValue(`nMaterialID_${f.sID}`, f.nMaterialID);
                        form.setValue(`nAmount_${f.sID}`, f.nAmount);
                        form.setValue(`nPricePerUnit_${f.sID}`, f.nPricePerUnit);
                        form.setValue(`sRemark`, f.sRemark);
                        getFormInitial();
                    })
                }, 500);
                form.setValue(`sReceiveType`, result.nReceiveType + "");
                form.setValue("sReceiveTypeOther", result.sReceiveTypeOther);
                form.setValue("dReceive", moment(result.nReceiveDate));
                form.setValue("sOrderNo", result.sOrderNo);
                setarrImport([...result.fFile]);
                setReceiveType(result.nReceiveType);
            }

        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        );
    };

    useEffect(() => {
        getFormInitial();
        getReceiveMaterialEdit(dataRow);
    }, []);


    const handleDelete = (arrID) => {
        DialogFn.Submit(`${I18n.SetText("PublishDoc.sConfirmDel")}`, () => {
            let arrClone = dataRow;
            arrClone.arrRows = arrClone.arrRows.filter((f) => !arrID.includes(f.sID));

            // เรียง Order ใหม่
            if (arrClone.arrRows.length > 0) {
                let nOrder = 1;
                arrClone.arrRows.forEach((f) => {
                    f.nOrder = nOrder;
                    nOrder++;
                });
            }

            setDataRow({
                ...arrClone,
                nDataLength: arrClone.arrRows.length,
            });
            DialogFn.Success("ลบข้อมูลสำเร็จ");
        });
    };

    return (
        <React.Fragment>
            <FormProvider {...form}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <RadioListItem
                            id={"sReceiveType"}
                            name={"sReceiveType"}
                            required={true}
                            options={[
                                { value: "1", label: "ซื้อระหว่างงวด" },
                                { value: "2", label: "อื่นๆ (ระบุ)" },
                            ]}
                            onChange={(e) => {
                                setReceiveType(e ? e : null)
                            }}

                            disabled={!isPermission}
                            label={`${I18n.SetText("Material.sReceiveMaterialtype")}`}
                        />
                    </Grid>
                    {nReceiveType == 2 ? (
                        <Grid item xs={12} md={5} sx={{ marginTop: 2 }}>
                            <TextBoxItem
                                required={false}
                                label={`${I18n.SetText("Material.sReceiveTypeOther")}`}
                                id={'sReceiveTypeOther'}
                                name={'sReceiveTypeOther'}
                                maxLength={250}
                                type={'text'}
                                IsShowMessageError
                                disabled={!isPermission}
                            />
                        </Grid>
                    ) : <Grid item xs={12} md={5} > </Grid>}
                    <Grid item xs={12} md={4}>
                        <TextBoxItem
                            required={true}
                            label={`${I18n.SetText("Material.sOrderNo")}`}
                            id={'sOrderNo'}
                            name={'sOrderNo'}
                            maxLength={250}
                            type={'text'}
                            IsShowMessageError
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <DatePickerItem
                            maxDate={moment()}
                            required={true}
                            name={"dReceive"}
                            id={"dReceive"}
                            label={`${I18n.SetText("Material.sReceiveDate")}`}
                            fullWidth
                            disabled={!isPermission || sID != null}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Typography>
                            {`${I18n.SetText("Material.sDoc")}`}
                            <span style={{ color: "red" }}> * </span>
                        </Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <UploadFile
                            id="sReceiveMaterialFile"
                            name={"sReceiveMaterialFile"}
                            label={""}
                            required={true}
                            arrFile={arrImport}
                            setarrFile={setarrImport}
                            sFolderTemp="ReceiveMaterialImage"
                            IsFolder={false}
                            IsMultiple={true}
                            Extension={[...Extension.ImagePDF]}
                            nLimitFile={30}
                            sLimitFile={"MB"}
                            onClearFile={() => { }}
                            sPositionText="right"
                            IsCrop={true}
                            cropRatio={16 / 9}
                            cropMovable={true}
                            cropResize={true}
                            cropShape='retangle'
                            modeDisplay='gallery'
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 1 }}>

                        <DataGrid
                            columns={dataColumn}
                            rows={dataRow}
                            isDisableColumnMenu={true}
                            onDelete={handleDelete}
                            isHiddenToolHead={true}
                            isHiddenPagination
                            isShowCheckBox={isPermission || sID == null}
                            onRowSelectable={(p) => sID == null}

                        />
                    </Grid>
                    {sID == null &&
                        <Grid item container justifyContent="flex-start" xs={12} md={12}>
                            <BtnAdd id={"btnSave"}
                                txt='เพิ่มข้อมูล'
                                IsDisabled={!isPermission || sID != null}
                                onClick={form.handleSubmit((e) => { onSumitTable(e) })}
                            />
                        </Grid>
                    }
                </Grid>
                <Grid container justifyContent="flex-start" sx={{ mt: 5 }}>
                    <Grid item xs={6} md={6}>
                        <BtnBack id={"btnBack"} onClick={() => onBack()} />
                    </Grid>

                    <Grid container item xs={6} md={6} justifyContent="flex-end">
                        <BtnSave
                            IsDisabled={!isPermission}
                            id={"btnSave"}
                            onClick={form.handleSubmit(
                                (e) => onSubmit(e, 1),
                                (err) => console.log("err", err)
                            )}
                        />
                    </Grid>
                </Grid>

                <DialogPreview
                    IsOpen={isOpen}
                    IsBackdropClick={false}
                    onClose={() => { setisOpen(false); }}
                    JsxDialogAction
                    CloseSave={sID == null ? true : false}
                    onClick={() => { onSummitRemark(); }}
                    Close={true}
                    sMaxWidth='sm'
                    bgColor={"#a07300"}
                    Color='white'
                    Title={'หมายเหตุ'}
                >
                    <Grid container justifyContent={"center"} >
                        <Grid item xs={12} md={12}>
                            <TextAreaItem
                                placeholder=""
                                label='หมายเหตุ'
                                name="sRemark"
                                maxLength={500}
                                id={"sRemark"}
                                required={false}
                                disabled={!isPermission || sID != null}
                            />
                        </Grid>
                    </Grid>
                </DialogPreview >
            </FormProvider>
        </React.Fragment >
    );
}
export default MaterialReceiveForm;